import * as React from "react";
import { MadMarqueeProps } from "./typings";
import { inject } from "mobx-react";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";

export const MadMarquee: React.FC<MadMarqueeProps> = inject("page")((props: MadMarqueeProps) => {
  const { page } = props;

  if (!page || !page.pageId) {
    return null;
  }

  return (
    <div className="MadMarqueeContainer">
      <CustomerNotification
        inputs={{
          xPageId: page.pageId,
          notificationLocation: CustomerNotificationLocation.FOOTER,
        }}
      />
    </div>
  );
});

export default MadMarquee;
